import React, { FC, HTMLProps } from "react";
import stl from "./index.module.scss";
import cn from "classnames";

interface Props extends HTMLProps<HTMLDivElement> {
  isOpen: boolean;
  setIsOpen?: (v: boolean) => void;
}

const Hamburger: FC<Props> = ({ isOpen, className, setIsOpen, ...props }) => {
  return (
    <div
      onClick={setIsOpen ? () => setIsOpen(!isOpen) : undefined}
      className={cn(className, stl.block, { [stl.open]: isOpen })}
      {...props}
    >
      <div className={stl.inner} />
    </div>
  );
};

export default Hamburger;
